import React, { Component, PropTypes } from 'react';
import * as B from 'react-bootstrap';
import moment from 'moment';
import './styles/schedule.scss';

class ChatSchedule extends Component {
  static propTypes = {
    schedule: PropTypes.object,
    outOfScheduleMessage: PropTypes.string.isRequired,
  };
  parseTime(time) {
    let duration = moment.duration(time, 'hours');
    return `${duration.hours()}:${duration.minutes()}`;
  }
  render() {
    let { schedule } = this.props;
    return (
      <div className="chat-schedule-wraper">
        <h5 className="chat-out-of-schedule-message">{ this.props.outOfScheduleMessage }</h5>
        {/* <p className="chat-schedule-tryagain">Intente nuevamente el { schedule.nextWorkingDate }</p>

        <h4>{`Horarios de atención (${schedule.timeZone})`}</h4>
        <B.Table striped>
          <thead>
            <tr>
              <th></th>
              <th>Lunes</th>
              <th>Martes</th>
              <th>Miércoles</th>
              <th>Jueves</th>
              <th>Viernes</th>
              <th>Sábado</th>
              <th>Domingo</th>
              <th>Feriado</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="chat-schedule-startrowheader">Desde</td>
              <td>{this.parseTime(shedule.mondayStart)}</td>
              <td>{this.parseTime(shedule.tuesdayStart)}</td>
              <td>{this.parseTime(shedule.wednesdayStart)}</td>
              <td>{this.parseTime(shedule.thursdayStart)}</td>
              <td>{this.parseTime(shedule.fridayStart)}</td>
              <td>{this.parseTime(shedule.saturdayStart)}</td>
              <td>{this.parseTime(shedule.sundayStart)}</td>
              <td>{this.parseTime(shedule.holidayStart)}</td>
            </tr>
            <tr>
              <td className="chat-schedule-endrowheader">Hasta</td>
              <td>{this.parseTime(schedule.mondayEnd)}</td>
              <td>{this.parseTime(schedule.tuesdayEnd)}</td>
              <td>{this.parseTime(schedule.wednesdayEnd)}</td>
              <td>{this.parseTime(schedule.thursdayEnd)}</td>
              <td>{this.parseTime(schedule.fridayEnd)}</td>
              <td>{this.parseTime(schedule.saturdayEnd)}</td>
              <td>{this.parseTime(schedule.sundayEnd)}</td>
              <td>{this.parseTime(schedule.holidayEnd)}</td>
            </tr>
          </tbody>
        </B.Table> */}
      </div>
    );
  }
}

export default ChatSchedule;



// WEBPACK FOOTER //
// ./components/chat/Schedule.js